import request from '@/utils/request'
import store from '@/store'

const url = store.getters.getPostUrl;
export default {
  selectStationList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/device/page',
      method: 'post',
      data:param
    })
  },
  getStationList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/station/stationList',
      method: 'post',
      params:param
    })
  },
  stationList() {
    return request({
      url: store.getters.getPostUrl + 'mes/station/stationList',
      method: 'post'
    })
  },
  insert(param) {
	  return request({
	    url: store.getters.getPostUrl + 'mes/device/'+param.deviceId,
	    method: 'put',
      data:param
	  })
  },
  del(param) {
  	  return request({
  	    url: store.getters.getPostUrl + 'mes/station/delete',
  	    method: 'post',
  	    params:param
  	  })
  },
	selectContentList(dictId) {
		return request({
		  url: store.getters.getPostUrl + 'mes/content/content',
		  method: 'post',
		  params:{'dictId': dictId}
		})
	},
	selectStationAllList(param) {
		return request({
		  url: store.getters.getPostUrl + 'mes/device/all',
		  method: 'post',
		  data:param
		})
	},
  alarmAllList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/alarm/page',
      method: 'post',
      data:param
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/stationPage/stationPage.js